var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.09961 20.4C4.09961 19.7373 4.63687 19.2 5.29961 19.2H19.6996C20.3624 19.2 20.8996 19.7373 20.8996 20.4C20.8996 21.0627 20.3624 21.6 19.6996 21.6H5.29961C4.63687 21.6 4.09961 21.0627 4.09961 20.4ZM8.05108 11.1515C8.51971 10.6828 9.27951 10.6828 9.74814 11.1515L11.2996 12.7029L11.2996 3.6C11.2996 2.93726 11.8369 2.4 12.4996 2.4C13.1623 2.4 13.6996 2.93726 13.6996 3.6L13.6996 12.7029L15.2511 11.1515C15.7197 10.6828 16.4795 10.6828 16.9481 11.1515C17.4168 11.6201 17.4168 12.3799 16.9481 12.8485L13.3481 16.4485C13.1231 16.6736 12.8179 16.8 12.4996 16.8C12.1813 16.8 11.8761 16.6736 11.6511 16.4485L8.05108 12.8485C7.58245 12.3799 7.58245 11.6201 8.05108 11.1515Z",
    fill: "#523280"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.a7359b3ea9c83d3d14b63b93c09248f4.svg";
export { ForwardRef as ReactComponent };